
























































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// eslint-disable-next-line sort-imports
import { namespace, State } from "vuex-class";
import AppInput from "@/components/global/AppInput.vue";
import AppModal from "@/components/global/AppModal.vue";
import AppTextarea from "@/components/global/AppTextarea.vue";
import BlacklistModule from "@/store/modules/blacklist";
import { BlacklistPayload } from "@/models/blacklist/BlacklistPayload";
import { BlacklistReasons } from "@/models/blacklist/BlacklistReasons";
import { BlacklistState } from "@/models/store/BlacklistState";
import { BlacklistTenants } from "@/models/blacklist/BlacklistTenants";
import { formatPhone } from "@/helpers/functions/format-phone-number";

const blacklist = namespace(BlacklistModule.name);

@Component({
  name: "BlacklistEdit",
  components: { AppInput, AppModal, AppTextarea }
})
export default class BlacklistEdit extends Vue {
  // ===== Props ===== //
  @Prop(Object) private readonly selectedTenant?: BlacklistTenants;
  @Prop(Object) private readonly editPayload?: BlacklistPayload;

  // ===== Store ===== //
  @State("blacklist") private readonly blacklist!: BlacklistState;

  // ===== Methods ===== //
  public formatPhone = formatPhone;

  @Emit("updateTenantName")
  public updateTenantName(value: string) {
    return value;
  }
  @Emit("updateTenantEmail")
  public updateTenantEmail(value: string | null) {
    return value;
  }
  @Emit("updateTenantPhone")
  public updateTenantPhone(value: string | null) {
    return value;
  }
  @Emit("updateTenantDriversLicense")
  public updateTenantDriversLicense(value: string | null) {
    return value;
  }
  @Emit("updateTenantLocationCode")
  public updateTenantLocationCode(value: string) {
    return value;
  }
  @Emit("updateTenantReason")
  public updateTenantReason(value: BlacklistReasons | string) {
    return value;
  }
  @Emit("updateTenantNote")
  public updateTenantNote(value: string | null) {
    return value;
  }

  // ===== Computed ===== //
  get blacklistReasons(): BlacklistReasons[] {
    return this.blacklist.blacklistReasons;
  }
  get facilities() {
    return this.$store.state.facility.facilitiesList;
  }
  get tenantName(): string {
    return this.selectedTenant!.customer_name;
  }
  set tenantName(newVal: string) {
    this.updateTenantName(newVal);
  }
  get tenantEmail(): string | null {
    return this.selectedTenant!.email_address;
  }
  set tenantEmail(newVal: string | null) {
    this.updateTenantEmail(newVal);
  }
  get tenantPhone(): string | null {
    return this.selectedTenant!.phone_number ? this.formatPhone(this.selectedTenant!.phone_number) : "";
  }
  set tenantPhone(newVal: string | null) {
    this.updateTenantPhone(newVal);
  }
  get tenantDriversLicense(): string | null {
    return this.selectedTenant!.drivers_license_number;
  }
  set tenantDriversLicense(newVal: string | null) {
    this.updateTenantDriversLicense(newVal);
  }
  get tenantLocation(): string {
    return this.selectedTenant!.location_code;
  }
  set tenantLocation(newVal: string) {
    this.updateTenantLocationCode(newVal);
  }
  get tenantReason(): BlacklistReasons | string {
    return this.selectedTenant!.reason;
  }
  set tenantReason(newVal: BlacklistReasons | string) {
    this.updateTenantReason(newVal);
  }
  get tenantNote(): string | null {
    return this.selectedTenant!.note;
  }
  set tenantNote(newVal: string | null) {
    this.updateTenantNote(newVal);
  }
  get phoneRegex() {
    return /^[2-9][0-9-]{11,12}$/;
  }
  get emailRules(): boolean {
    return !this.tenantPhone &&
      !this.editPayload!.phone_number &&
      !this.tenantDriversLicense &&
      !this.editPayload!.drivers_license_number;
  }
  get phoneRules(): boolean {
    return !this.tenantEmail &&
      !this.editPayload!.email_address &&
      !this.tenantDriversLicense &&
      !this.editPayload!.drivers_license_number;
  }
  get driversLicenseRules(): boolean {
    return !this.tenantEmail &&
      !this.editPayload!.email_address &&
      !this.tenantPhone &&
      !this.editPayload!.phone_number;
  }
}
